import { css } from '@emotion/react';
import { Colors } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { SubMenuHeading } from './SubMenuHeading';
import { SubMenuList } from './SubMenuList';
import { ICON_SIZE, HEADING_GAP } from './constants';
const Styles = labelStyles('MegaMenuSubmenu', {
    root: css({
        color: Colors.earth,
        display: 'grid',
        gap: '4%',
        gridTemplateColumns: 'repeat(3, minmax(0px, max-content))',
        gridTemplateRows: 'auto',
        height: '100%',
    }),
    group: css({
        color: Colors.inherit,
        '&:hover, &:focus, &:focus-within': {
            color: Colors.zapier,
        },
    }),
    listWrapper: (hasIcon) => css({
        paddingLeft: hasIcon ? `${ICON_SIZE + HEADING_GAP}px` : 0,
    }),
});
export const MegaMenuSubmenu = (props) => {
    const { links } = props;
    return (isolateComponent("ul", { css: Styles.root }, links.map((link) => (isolateComponent("li", { key: link.text, css: Styles.group },
        isolateComponent("div", { role: link.submenu ? 'group' : 'presentation' },
            isolateComponent(SubMenuHeading, { link: link, onCloseMenu: props.onCloseMenu }),
            link.submenu && (isolateComponent("div", { css: Styles.listWrapper(!!link.icon) },
                isolateComponent(SubMenuList, { submenu: link.submenu, onCloseMenu: props.onCloseMenu })))))))));
};
//# sourceMappingURL=MegaMenuSubmenu.js.map
// @zapier/universal-layout@8.3.7 (9c955f548)
